module.exports = __webpack_public_path__ + "static/surface-studio-28de741318601d5ad77ac1188557e85a.png";